import React, { ComponentProps } from 'react'
import styled from 'styled-components'
import cn from 'clsx'
import SvgIcon from 'LuxKit/SvgIcon'

const STAR_COLOUR = '#F1BF42'

const HalfStarPath = styled.path`
  fill: ${STAR_COLOUR};
`

const FullStarPath = styled.path`
  fill: ${props => props.theme.palette.neutral.default.five};

  &.filled {
    fill: ${STAR_COLOUR};
  }
`

interface Props {
  kind: 'empty' | 'half' | 'filled'
  size?: ComponentProps<typeof SvgIcon>['size']
}

function StarRatingStar(props: Props) {
  const { kind, size } = props

  return <SvgIcon viewBox="0 0 24 24" fill="none" size={size}>
    <FullStarPath
      className={cn({ filled: kind === 'filled' })}
      d="M22 10.1C22.1 9.6 21.7 9 21.2 9L15.5 8.2L12.9 3C12.8 2.8 12.7 2.7 12.5 2.6C12 2.3 11.4 2.5 11.1 3L8.6 8.2L2.9 9C2.6 9 2.4 9.1 2.3 9.3C1.9 9.7 1.9 10.3 2.3 10.7L6.4 14.7L5.4 20.4C5.4 20.6 5.4 20.8 5.5 21C5.8 21.5 6.4 21.7 6.9 21.4L12 18.7L17.1 21.4C17.2 21.5 17.4 21.5 17.6 21.5C17.7 21.5 17.7 21.5 17.8 21.5C18.3 21.4 18.7 20.9 18.6 20.3L17.6 14.6L21.7 10.6C21.9 10.5 22 10.3 22 10.1Z"
    />
    {kind === 'half' && <HalfStarPath
      d="M12 2.45905C11.6452 2.45962 11.3035 2.66076 11.1 3L8.6 8.2L2.9 9C2.6 9 2.4 9.1 2.3 9.3C1.9 9.7 1.9 10.3 2.3 10.7L6.4 14.7L5.4 20.4C5.4 20.6 5.4 20.8 5.5 21C5.8 21.5 6.4 21.7 6.9 21.4L12 18.7V2.45905Z"
    />}
  </SvgIcon>
}

export default StarRatingStar
